export default "__VITE_ASSET__Bm3nCwez__"